var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['counter', { 'length-warning': _vm.warning, visible: _vm.visible }]},[_vm._v(_vm._s(_vm.counterText))])}
var staticRenderFns = []

export { render, staticRenderFns }